import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/registration`;

/** Admin-only helpers (master parent options). User registration is app-only. */
class RegistrationServices {
  async getParentOptions() {
    return requestToken.get(`${API_ROUTE}/parent-options`);
  }
}

export default RegistrationServices;
